export default "__VITE_ASSET__CSxEXtJu__"